import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    condition: null
  },
  mutations: {
    // 更新查询条件
    updateCondition(state, data) {
      state.condition = data || null;
    }
  },
  actions: {
    // // 获取用户信息接口
    // getInfo({ commit }, $api) {
    //   $api("user", "getUserInfo", {}).then(res => {
    //     commit("updateInfo", res.userAndToken);
    //   });
    // }
  },
  modules: {},
  strict: process.env.NODE_ENV !== "production"
});
